<template>
  <div>
    <progress-bar :isLoading="isLoading"
    ></progress-bar>
      <v-list v-if="ldm" two-line>
        <v-subheader>LDM</v-subheader>
        <v-list-item>
          <v-list-item-content>
          <v-list-item-title>
            Received at
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ ldm.createdAt | localMoment('YYYY-MM-DD HH:mm') }}
          </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Content
            </v-list-item-title>
            <v-list-item-subtitle>
              <pre style="overflow: auto">{{ldm.loadMessage}}</pre>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

      </v-list>
  </div>
</template>

<script>

import Flights from '@/api/flights.js'
import ProgressBar from '@/components/ProgressBar'

export default {
  props: {
    flightId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    ldm: null
  }),
  created() {
    this.isLoading = true
    Flights.flightLatestLdm(this.flightId)
        .then(({data}) => {
          this.ldm = data
        })
        .finally(() => {
      this.isLoading = false
    })
  },
  components: {
    ProgressBar
  },
  methods: {
  },
  computed: {
  }
}
</script>
